import { object, string } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { validateObjectId } from '@shared/utils';

import { DESCRIPTION_MAX_LENGTH, getRichTextTextLength, isRichTextEffectivelyEmpty } from './utils';

export const CASINO_BUTTON_TEXT_MAX_LENGTH = 26;
export const TOP_LABEL_TEXT_MAX_LENGTH = 38;
export const BADGE_TEXT_MAX_LENGTH = 35;

export interface SpinBannerForm {
  description: string;
  casinoName: string;
  casinoButtonLink: string;
  casinoButtonText: string;
  promocodeRewardDescription: string;
  logoId: string;
  topLabelText: string;
  badgeText: string;
}

const REQUIRED = YUP_ERRORS_MESSAGES.REQUIRED;

export const initialValues: SpinBannerForm = {
  description: '',
  casinoName: '',
  casinoButtonLink: '',
  casinoButtonText: '',
  promocodeRewardDescription: '',
  logoId: '',
  topLabelText: '',
  badgeText: '',
};

export const validationSchema = object().shape({
  description: string()
    .test('description-required', REQUIRED, (value) => !isRichTextEffectivelyEmpty(value))
    .test(
      'description-max-length',
      `Description must be at most ${DESCRIPTION_MAX_LENGTH} characters (HTML tags excluded)`,
      (value) => (value ? getRichTextTextLength(value) <= DESCRIPTION_MAX_LENGTH : true)
    ),
  casinoName: string().required(REQUIRED),
  casinoButtonLink: string().required(REQUIRED),
  casinoButtonText: string()
    .required(REQUIRED)
    .max(CASINO_BUTTON_TEXT_MAX_LENGTH, `Must be at most ${CASINO_BUTTON_TEXT_MAX_LENGTH} characters`),
  promocodeRewardDescription: string().test(
    'promocode-reward-description-required',
    REQUIRED,
    (value) => !isRichTextEffectivelyEmpty(value)
  ),
  topLabelText: string().max(TOP_LABEL_TEXT_MAX_LENGTH, `Must be at most ${TOP_LABEL_TEXT_MAX_LENGTH} characters`),
  badgeText: string().max(BADGE_TEXT_MAX_LENGTH, `Must be at most ${BADGE_TEXT_MAX_LENGTH} characters`),
  logoId: string().required(YUP_ERRORS_MESSAGES.IMAGE).test({
    message: YUP_ERRORS_MESSAGES.OBJECT_ID,
    test: validateObjectId,
  }),
});
